export default __webpack_public_path__ + "static/media/3-2-3.00d58cff.jpg";